import { ReactComponent as NoneIcon } from '../icons/none.svg'
import Styles from '../Prompt.module.scss'

const InvalidPhoto = () => (
  <div className={Styles.previewContainer}>
    <div className={Styles.invalidPhotoContainer}>
      <div className={Styles.iconWrapper}>
        <NoneIcon />
      </div>
      <p>Invalid URL or Photo</p>
    </div>
  </div>
)

export default InvalidPhoto
